import { get, toLower } from 'lodash'
const { ARTIST_OVERRIDE } = process.env

function isTeachingArtistEnabled(communityConfig) {
  return (
    get(communityConfig, 'teachingArtist.enabled') ||
    toLower(ARTIST_OVERRIDE) === 'true'
  )
}

export default isTeachingArtistEnabled
